import React from "react";
import { RadioGroup, Radio } from "theme/components/atoms/Form/Input";
import FormItem from "theme/components/molecules/Form/Item";
import CustomOptionLabelWithPrice from "./CustomOptionLabelWithPrice";

const RadioOption = (props) => {
  const { values } = props;

  return (
    <FormItem label={props.title}>
      <RadioGroup
        name={props.option_id}
        values={props.values.map((value) => value.option_value_id)}
        value={props.selectedOption}
        required={props.required}
        renderRadio={(props) => {
          const optionValue = values.find(
            (value) => value.option_value_id === props.value
          );
          return (
            <Radio
              {...props}
              label={<CustomOptionLabelWithPrice option={optionValue} />}
            />
          );
        }}
      />
    </FormItem>
  );
};

export default RadioOption;
